import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Button,
  Card,
  Input,
  message,
  Modal,
  PageHeader,
  Select,
  Space,
  Spin,
} from "antd";
import { DeleteOutlined, DownloadOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { LanguageContext } from "../../context/LanguageContext";
import _ from "lodash";
import axios from "axios";
import "../viewFormModel.css";
import { professionalService, userService } from "../../_services";
import { professionalAction } from "../../_actions";
import moment from "moment";
import { adminService } from "../../_services/admin.service";
import domtoimage from "dom-to-image-more";
export const ViewGunaDetails = ({
  dataStates,
  name,
  address,
  pc_crimetitles,
  loading,
  user_details,
  masterId,
  closeGunaViewModel,
}) => {
  const location = useLocation();
  // const isTwoPlusReport =
  //   location?.pathname?.indexOf("reportPlus2Report") !== -1;
  const canShowGunhaRemove =
    !!user_details?.is_merge;
  const [id, setId] = useState();
  const [mergeData, setMergeData] = useState();
  const [conform, setConform] = useState(false);
  const [complete, setComplete] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [preventiveAction, setPreventiveAction] = useState([]);
  const [selectedGunha, setSelectedGunha] = useState(null);
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [deleteNotifyVisible, setDeleteNotifyVisible] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteReason, setDeleteReason] = useState(undefined);
  const [ipAddress, setIpAddress] = useState("");
  const [mergeVerificationOpen, setMergeVerificationOpen] = useState(false);
  const [mergeTipVisible, setMergeTipVisible] = useState(false);
  const mergeTipRef = React.useRef(null);
  const downloadContentRef = React.useRef(null);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const DELETE_REASON_OPTIONS = [
    "नजरचुकीने भरला गेला.",
    "अनेकवेळा भरला गेला.",
    "गुन्हा भरताना चूक झाली",
  ];
  const getPreventiveData = () => {
    professionalAction.getPreventiveAction().then((res) => {
      res &&
        res.text().then((preventiveList) => {
          const data = [];
          preventiveList &&
            JSON.parse(preventiveList).data.forEach((item) => {
              data.push(item);
            });
          setPreventiveAction(data);
        });
    });
  };
  const getPreventiveName = (id) => {
    if (preventiveAction && preventiveAction?.length > 0) {
      return (
        _.filter(preventiveAction, function (o) {
          return o.id === Number(id);
        })[0] &&
        _.filter(preventiveAction, function (o) {
          return o.id === Number(id);
        })[0].name
      );
    }
  };

  const getClientIp = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_GEOLOCATION_URL}/json/`,
      );
      setIpAddress(res.data.IPv4 || "");
    } catch (error) {
      console.error("IP fetch failed", error);
      setIpAddress("");
    }
  };

  useEffect(() => {
    getPreventiveData();
    getClientIp();
  }, []);

  useEffect(() => {
    if (!mergeTipVisible) return undefined;
    const handleOutsideClick = (event) => {
      if (
        mergeTipRef.current &&
        !mergeTipRef.current.contains(event.target)
      ) {
        setMergeTipVisible(false);
      }
    };
    const handleEscape = (event) => {
      if (event.key === "Escape") setMergeTipVisible(false);
    };
    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [mergeTipVisible]);

  const GunhaHide = async (gunha) => {
    setDeleteLoading(true);
    let currentIp = ipAddress;
    if (!currentIp) {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_GEOLOCATION_URL}/json/`,
        );
        currentIp = res.data.IPv4 || "";
        setIpAddress(currentIp);
      } catch (error) {
        console.error("IP fetch failed", error);
      }
    }
    const temp = {
      id: gunha.id,
      userid: user_details?.id,
      masterId: masterId,
      city: user_details?.cityId,
      registernumber: gunha.registernumber,
      district: user_details.districtId,
      lawSection: gunha.lawSection,
      ip_address: currentIp,
      reason: gunha.reason || deleteReason,
    };
    console.log("temp", temp);
    console.log("user_details", user_details);
    adminService
      .GunhaHide(temp)
      .then(() => {
        message.success("Hide successfully");
        setDeleteNotifyVisible(false);
        setSelectedGunha(null);
        setDeleteReason(undefined);
        window.location.reload();
      })
      .catch(() => {
        message.error("Something went wrong");
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };

  const getGunhaLabel = (ginfo) => {
    const number = ginfo?.registernumber || "-";
    let year = ginfo?.registernumberYear || "";
    if (year && moment(year).isValid()) {
      year = moment(year).format("YYYY");
    }
    return year ? `${number} / ${year}` : `${number}`;
  };

  const getLawSectionData = (ginfo) => {
    if (!Array.isArray(ginfo?.kalamAndkayda) || !ginfo.kalamAndkayda.length) {
      return { nodes: [], text: "" };
    }

    const grouped = ginfo.kalamAndkayda.reduce((acc, curr) => {
      if (!acc[curr.rulesName]) {
        acc[curr.rulesName] = [];
      }
      acc[curr.rulesName].push(curr.kalam);
      return acc;
    }, {});

    const nodes = Object.entries(grouped).map(([rulesName, kalams], i) => (
      <div key={i}>
        {rulesName}- {kalams.join(", ")}
      </div>
    ));

    const text = Object.entries(grouped)
      .map(([rulesName, kalams]) => `${rulesName}- ${kalams.join(", ")}`)
      .join("; ");

    return { nodes, text };
  };

  const openDeleteConfirm = (ginfo, lawSection) => {
    setSelectedGunha({ ...ginfo, lawSection });
    setDeleteConfirmVisible(true);
  };

  const onDeleteYes = () => {
    setDeleteConfirmVisible(false);
    setDeleteReason(undefined);
    setDeleteNotifyVisible(true);
  };

  const onDeleteNo = () => {
    setDeleteConfirmVisible(false);
    setSelectedGunha(null);
    setDeleteReason(undefined);
  };

  const onDeleteReasonChange = (value) => {
    setDeleteReason(value);
  };

  const onDeleteOk = () => {
    if (!deleteReason) {
      message.warning("कृपया कारण निवडा");
      return;
    }
    if (selectedGunha?.id) {
      GunhaHide({ ...selectedGunha, reason: deleteReason });
    }
  };

  useEffect(() => {
    setId();
    setMergeData();
    setConform(false);
    setComplete(false);
    setVerifyLoading(false);
    setSelectedGunha(null);
    setDeleteConfirmVisible(false);
    setDeleteNotifyVisible(false);
    setDeleteReason(undefined);
    setMergeVerificationOpen(false);
  }, [masterId]);

  const handleComplete = () => {
    setComplete(!complete);
  };
  const handleConfrom = () => {
    setConform(!conform);
  };
  console.log("professionals", dataStates);
  console.log("loading", loading);
  const { language, setLanguage, t } = useContext(LanguageContext);
  const getCrimeTitle = (id) => {
    if (pc_crimetitles && pc_crimetitles.length) {
      return (
        _.filter(pc_crimetitles, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_crimetitles, function (o) {
          return o.id === id;
        })[0].crime_title
      );
    }
  };

  const handleSubmit = () => {
    const guna_mege = mergeData?.gunhaInfor?.map((item) => {
      // Destructure to remove masterId
      const { masterId, ...rest } = item;

      return {
        ...rest,
        kalamAndkayda:
          item?.kalamAndkayda?.map((k) => {
            const { masterId, ...kRest } = k;
            return kRest;
          }) || [],
        membersList:
          item?.membersList?.map((m) => {
            const { masterId, ...mRest } = m;
            return mRest;
          }) || [],
        noticeInfo:
          item?.noticeInfo?.map((m) => {
            const { masterId, ...mRest } = m;
            return mRest;
          }) || [],
        arrestInfo:
          item?.arrestInfo?.map((m) => {
            const { masterId, ...mRest } = m;
            return mRest;
          }) || [],
      };
    });

    // Get all guna IDs
    const guanid = mergeData?.gunhaInfor?.map((item) => item.id) || [];

    // Get all kalamAndkayda IDs
    const kk_id =
      mergeData?.gunhaInfor?.flatMap(
        (item) => item.kalamAndkayda?.map((k) => k.id) || [],
      ) || [];

    const notice_id =
      mergeData?.gunhaInfor?.flatMap(
        (item) => item.noticeInfo?.map((k) => k.id) || [],
      ) || [];
    const arrest_id =
      mergeData?.gunhaInfor?.flatMap(
        (item) => item.arrestInfo?.map((k) => k.id) || [],
      ) || [];

    const preventiveInfo = mergeData?.preventiveInfo || [];
    const preventive_id = preventiveInfo?.flatMap((item) => item.id) || [];
    const otherInfo = mergeData?.otherInfo || [];
    const otherinfo_id = otherInfo.flatMap((item) => item.id) || [];
    const temp = {
      primary_masterId: masterId,
      secondary_masterId: id,
      guna_mege: guna_mege,
      gunaId: guanid,
      kk_id: kk_id,
      userId: user_details?.id,
      secondary_name: mergeData?.basicInfo[0]?.name,
      primary_name: name,
      preventiveInfo: preventiveInfo,
      preventive_id: preventive_id,
      notice_id: notice_id,
      arrest_id: arrest_id,
    };
    console.log("temp", temp);
    userService.mergeGunaData(temp).then((res) => {
      console.log("res", res);
      handleConfrom();
      handleComplete();
    });
  };
  const getcriminalbyid = () => {
    if (!id) return;
    if (String(id).trim() === String(masterId).trim()) {
      Modal.warning({
        title: "सूचना",
        content: `कृपया ${id} हा CMIS ID वेगळ्या प्रोफाइल मध्ये मर्ज करावा लागेल, सेम प्रोफाइल मध्ये करू शकत नाही.`,
        centered: true,
        okText: "Ok",
      });
      return;
    }
    setVerifyLoading(true);
    setMergeData();
    professionalService
      .getCriminalsById(id)
      .then((res) => {
        setMergeData(res);
      })
      .finally(() => {
        setVerifyLoading(false);
      });
  };

  function parseDateAnyFormat(dateStr) {
    dateStr = dateStr?.trim();
    let dateObj = new Date(dateStr);
    if (!isNaN(dateObj)) return dateObj;
    dateStr = dateStr?.replace(/[-.]/g, "/");
    const parts = dateStr?.split(/[/\s,:]+/);
    if (parts?.length === 3) {
      if (parts[0]?.length === 4) {
        if (parseInt(parts[1]) > 12) {
          dateObj = new Date(`${parts[0]}/${parts[2]}/${parts[1]}`);
        } else {
          dateObj = new Date(`${parts[0]}/${parts[1]}/${parts[2]}`);
        }
      } else if (parts[2]?.length === 4) {
        dateObj = new Date(`${parts[2]}/${parts[1]}/${parts[0]}`);
      }
    } else if (parts?.length === 6) {
      if (parts[0]?.length === 4) {
        dateObj = new Date(
          `${parts[0]}/${parts[1]}/${parts[2]} ${parts[3]}:${parts[4]}:${parts[5]}`,
        );
      } else {
        dateObj = new Date(
          `${parts[2]}/${parts[1]}/${parts[0]} ${parts[3]}:${parts[4]}:${parts[5]}`,
        );
      }
    }
    return !isNaN(dateObj) ? dateObj : "Invalid Date";
  }
  const sortedDataStates = [...dataStates].sort((a, b) => {
    const dateA = parseDateAnyFormat(a?.dateTime);
    const dateB = parseDateAnyFormat(b?.dateTime);

    // If both dates are valid
    if (dateA !== "Invalid Date" && dateB !== "Invalid Date") {
      if (dateA > dateB) return -1; // latest first
      if (dateA < dateB) return 1;
      // If dates are equal, sort by registernumber
      if (a.registernumber < b.registernumber) return -1;
      if (a.registernumber > b.registernumber) return 1;
      return 0;
    }
    // If only A is invalid, A goes after B
    if (dateA === "Invalid Date" && dateB !== "Invalid Date") return 1;
    // If only B is invalid, B goes after A
    if (dateA !== "Invalid Date" && dateB === "Invalid Date") return -1;
    // If both are invalid, sort by registernumber
    if (a.registernumber < b.registernumber) return -1;
    if (a.registernumber > b.registernumber) return 1;
    return 0;
  });
  const visibleData = sortedDataStates.filter((item) => !item.is_hide);

  const downloadGunaDetailsImage = async () => {
    const node = downloadContentRef.current;
    if (!node) {
      return;
    }

    setDownloadLoading(true);
    const hideEls = node.querySelectorAll(
      ".guna-sr-trash, #guna-details-download-btn",
    );
    const previousDisplays = [];
    hideEls.forEach((el) => {
      previousDisplays.push([el, el.style.display]);
      el.style.display = "none";
    });

    const overflowEls = [node, ...node.querySelectorAll("*")].filter((el) => {
      const style = window.getComputedStyle(el);
      return (
        style.overflow === "auto" ||
        style.overflow === "scroll" ||
        style.overflowX === "auto" ||
        style.overflowX === "scroll" ||
        style.overflowY === "auto" ||
        style.overflowY === "scroll"
      );
    });
    const previousOverflow = overflowEls.map((el) => ({
      el,
      overflow: el.style.overflow,
      overflowX: el.style.overflowX,
      overflowY: el.style.overflowY,
      width: el.style.width,
    }));
    overflowEls.forEach((el) => {
      el.style.overflow = "visible";
      el.style.overflowX = "visible";
      el.style.overflowY = "visible";
    });

    const originalBackground = node.style.background;
    node.style.background = "#ffffff";

    const footer = document.createElement("div");
    footer.id = "guna-temp-footer";
    footer.innerText = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;
    footer.style.width = "100%";
    footer.style.textAlign = "center";
    footer.style.marginTop = "20px";
    footer.style.fontSize = "13px";
    footer.style.padding = "10px 0";
    node.appendChild(footer);

    try {
      const blob = await domtoimage.toBlob(node, {
        bgcolor: "#ffffff",
        cacheBust: true,
        width: Math.ceil(node.scrollWidth),
        height: Math.ceil(node.scrollHeight),
        style: {
          overflow: "visible",
          overflowX: "visible",
          overflowY: "visible",
        },
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      const safeName = String(name || "accused")
        .trim()
        .replace(/\s+/g, "_");
      link.href = url;
      link.download = `CMIS_${masterId || "guna"}_${safeName}.png`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
      message.error(t("download") || "Download failed");
    } finally {
      const addedFooter = document.getElementById("guna-temp-footer");
      if (addedFooter) addedFooter.remove();
      previousDisplays.forEach(([el, display]) => {
        el.style.display = display;
      });
      previousOverflow.forEach(({ el, overflow, overflowX, overflowY, width }) => {
        el.style.overflow = overflow;
        el.style.overflowX = overflowX;
        el.style.overflowY = overflowY;
        el.style.width = width;
      });
      node.style.background = originalBackground;
      setDownloadLoading(false);
    }
  };

  return loading ? (
    <div
      style={{
        minHeight: 200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spin size="large" />
    </div>
  ) : (
    <>
      <div ref={downloadContentRef} style={{ background: "#ffffff" }}>
      <div
        style={{
          marginBottom: "20px",
          padding: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: "14px",
            fontWeight: "600",
            marginBottom: "8px",
          }}
        >
          CMIS ID : {masterId}
        </div>

        <div
          style={{
            fontSize: "15px",
            fontWeight: "600",
            display: "flex",
            gap: "6px",
            alignItems: "flex-start",
            marginBottom: "6px",
          }}
        >
          <span style={{ whiteSpace: "nowrap" }}>
            {t("name_of_the_accused")}:
          </span>
          <span style={{ fontWeight: "500", wordBreak: "break-word" }}>
            {name}
          </span>
        </div>
        <div
          style={{
            fontSize: "15px",
            fontWeight: "600",
            display: "flex",
            gap: "6px",
            alignItems: "flex-start",
          }}
        >
          <span style={{ whiteSpace: "nowrap" }}>{t("address")}:</span>
          <span style={{ fontWeight: "500", wordBreak: "break-word" }}>
            {address}
          </span>
        </div>
        </div>
        <Button
          id="guna-details-download-btn"
          type="primary"
          icon={<DownloadOutlined />}
          loading={downloadLoading}
          onClick={downloadGunaDetailsImage}
          disabled={!dataStates || !dataStates.length}
        >
          {t("download")}
        </Button>
      </div>

      <PageHeader ghost={false} onBack={false}>
        {dataStates && dataStates.length > 0 && (
          <div className="ant-table-wrapper" style={{ overflowX: "auto" }}>
            <table
              className="ant-table ant-table-bordered"
              style={{ border: "1px solid rgb(26, 20, 20)", width: "100%" }}
            >
              <thead className="ant-table-thead">
                <tr>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("crime")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("title")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("crime_police_station")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("crime_register_number")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("crime_registration_date")}
                  </th>
                  <th
                    className="ant-table-cell"
                    style={{ border: "1px solid rgb(26, 20, 20)" }}
                  >
                    {t("law") + " - " + t("section")}
                  </th>
                </tr>
              </thead>
              <tbody className="ant-table-tbody">
                {visibleData
                  .filter((ginfo) => !ginfo.is_hide)
                  .map((ginfo, index) => {
                    const { nodes: lawSection, text: lawSectionText } =
                      getLawSectionData(ginfo);
                    return (
                      <tr key={index}>
                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {canShowGunhaRemove && visibleData.length >= 2 ? (
                            selectedGunha?.id === ginfo.id ? (
                              <span
                                key={`trash-${ginfo.id}`}
                                className="guna-sr-trash"
                                title="Delete"
                                role="button"
                                tabIndex={0}
                                onClick={() =>
                                  openDeleteConfirm(ginfo, lawSectionText)
                                }
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    openDeleteConfirm(ginfo, lawSectionText);
                                  }
                                }}
                              >
                                <DeleteOutlined />
                              </span>
                            ) : (
                              <span
                                key={`sr-${ginfo.id}`}
                                className="guna-sr-no"
                                role="button"
                                tabIndex={0}
                                onClick={() => setSelectedGunha(ginfo)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    setSelectedGunha(ginfo);
                                  }
                                }}
                              >
                                {index + 1}
                              </span>
                            )
                          ) : (
                            index + 1
                          )}
                        </td>
                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {getCrimeTitle(ginfo.heading)}
                        </td>
                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {ginfo?.districtName}
                        </td>
                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {ginfo.registernumber}
                        </td>
                        <td
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {(() => {
                            const parsed = parseDateAnyFormat(ginfo?.dateTime);
                            if (parsed === "Invalid Date") return "-";
                            return parsed.toLocaleDateString("en-GB");
                          })()}
                        </td>
                        <td
                          className="ant-table-cell law-section-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {lawSection.length > 0 ? lawSection : "-"}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </PageHeader>
      <PageHeader>
        {user_details?.is_merge == true && (
          <>
            <div className="guna-merge-toggle-wrap">
              <button
                type="button"
                className={`guna-merge-label-pill guna-merge-toggle-btn ${
                  mergeVerificationOpen ? "active" : ""
                }`}
                onClick={() =>
                  setMergeVerificationOpen((prevOpen) => !prevOpen)
                }
              >
                Profile Merge
              </button>
              <div className="guna-merge-tip-wrap" ref={mergeTipRef}>
                <span
                  className={`guna-merge-info-icon${
                    mergeTipVisible ? " active" : ""
                  }`}
                  role="button"
                  tabIndex={0}
                  aria-expanded={mergeTipVisible}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setMergeTipVisible((open) => !open);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setMergeTipVisible((open) => !open);
                    }
                  }}
                >
                  <InfoCircleOutlined />
                </span>
                {mergeTipVisible && (
                  <div className="guna-merge-tip-panel" role="tooltip">
                    <div className="guna-merge-tip-body">
                      <div className="guna-merge-tip-title">
                        <InfoCircleOutlined /> Tip
                      </div>
                      <p className="guna-merge-tip-text">
                        या सुविधेचा वापर करून इतर आरोपी चे सर्व गुन्हे ,
                        प्रतिबंधक कारवाई , नोटिस , अटक नोंद वरील संबंधित आरोपी
                        च्या प्रोफाइल मर्ज करू शकता.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {mergeVerificationOpen && (
              <Card
                size="small"
                className="guna-merge-card"
                style={{ marginBottom: 12 }}
              >
                <div className="guna-cmis-search">
                  <label className="guna-cmis-label">
                    CMIS Id <span style={{ color: "#cf1322" }}>*</span>
                  </label>
                  <Input
                    size="middle"
                    placeholder="Enter CMIS Id"
                    value={id}
                    className="guna-cmis-input"
                    onChange={(e) => setId(e.target.value)}
                    onPressEnter={() => {
                      if (id && !mergeData) getcriminalbyid();
                    }}
                  />
                  <Button
                    type="primary"
                    className={`modern-button modern-button-primary guna-verify-btn guna-ai-btn ${
                      id && !mergeData ? "guna-verify-btn-pulse" : ""
                    }`}
                    onClick={() => getcriminalbyid()}
                    loading={verifyLoading}
                  >
                    Verify
                  </Button>
                </div>

                {mergeData && (
                  <div className="guna-merge-result" style={{ marginTop: 12 }}>
                    <div className="guna-merge-info">
                      <span className="info-label">CMIS Id :</span>{" "}
                      <span className="info-value" style={{ marginRight: 16 }}>
                        {id || "-"}
                      </span>
                      <span className="info-label">{t("name")} :</span>{" "}
                      <span
                        className="info-value"
                        style={{ marginRight: 16, color: "#1890ff" }}
                      >
                        {mergeData?.basicInfo?.[0]?.name || "-"}
                      </span>
                      <span className="info-label">{t("address")} :</span>{" "}
                      <span className="info-value">
                        {mergeData?.basicInfo?.[0]?.address || "-"}
                      </span>
                    </div>

                <div
                  className="section-heading-minimal border"
                  style={{ margin: "8px 0 6px" }}
                >
                  {t("crime_information")}
                </div>

                <div
                  className="ant-table-wrapper"
                  style={{ overflowX: "auto", marginBottom: 12 }}
                >
                  <table
                    className="ant-table ant-table-bordered"
                    style={{
                      border: "1px solid rgb(26, 20, 20)",
                      width: "100%",
                    }}
                  >
                    <thead className="ant-table-thead">
                      <tr>
                        <th
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {t("crime")}
                        </th>
                        <th
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {t("title")}
                        </th>
                        <th
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {t("crime_police_station")}
                        </th>
                        <th
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {t("crime_register_number")}
                        </th>
                        <th
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {t("crime_registration_date")}
                        </th>
                        <th
                          className="ant-table-cell"
                          style={{ border: "1px solid rgb(26, 20, 20)" }}
                        >
                          {t("law") + " - " + t("section")}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="ant-table-tbody">
                      {(mergeData?.gunhaInfor || []).map((ginfo, index) => {
                        const { nodes: lawSection } = getLawSectionData(ginfo);
                        return (
                          <tr key={index}>
                            <td
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {index + 1}
                            </td>
                            <td
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {getCrimeTitle(ginfo.heading)}
                            </td>
                            <td
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {ginfo?.districtName}
                            </td>
                            <td
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {ginfo.registernumber}
                            </td>
                            <td
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {(() => {
                                const parsed = parseDateAnyFormat(
                                  ginfo?.dateTime,
                                );
                                if (parsed === "Invalid Date") return "-";
                                return parsed.toLocaleDateString("en-GB");
                              })()}
                            </td>
                            <td
                              className="ant-table-cell law-section-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {lawSection.length > 0 ? lawSection : "-"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {mergeData?.preventiveInfo?.length > 0 && (
                  <>
                    <div
                      className="section-heading-minimal border"
                      style={{ margin: "8px 0 6px" }}
                    >
                      {t("preventive_action")}
                    </div>
                    <div
                      className="ant-table-wrapper"
                      style={{ overflowX: "auto", marginBottom: 12 }}
                    >
                      <table
                        className="ant-table ant-table-bordered"
                        style={{
                          border: "1px solid rgb(26, 20, 20)",
                          width: "100%",
                        }}
                      >
                        <thead className="ant-table-thead">
                          <tr>
                            <th
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {t("sr.no")}
                            </th>
                            <th
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {t("preventive_action")}
                            </th>
                            <th
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {t("chapter_case_number")}
                            </th>
                            <th
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {t("action_taken_police_station")}
                            </th>
                            <th
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {t("period_from")}
                            </th>
                            <th
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {t("period_to")}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="ant-table-tbody">
                          {mergeData.preventiveInfo.map((ginfo, index) => (
                            <tr key={index}>
                              <td
                                className="ant-table-cell"
                                style={{ border: "1px solid rgb(26, 20, 20)" }}
                              >
                                {index + 1}
                              </td>
                              <td
                                className="ant-table-cell"
                                style={{ border: "1px solid rgb(26, 20, 20)" }}
                              >
                                {ginfo.preventive_action
                                  ? getPreventiveName(ginfo.preventive_action)
                                  : "-"}
                              </td>
                              <td
                                className="ant-table-cell"
                                style={{ border: "1px solid rgb(26, 20, 20)" }}
                              >
                                {ginfo.chaptorCase || "-"}
                              </td>
                              <td
                                className="ant-table-cell"
                                style={{ border: "1px solid rgb(26, 20, 20)" }}
                              >
                                {ginfo.action_taken_police_station || "-"}
                              </td>
                              <td
                                className="ant-table-cell"
                                style={{ border: "1px solid rgb(26, 20, 20)" }}
                              >
                                {ginfo.date_from &&
                                moment(
                                  parseDateAnyFormat(ginfo.date_from),
                                ).isValid()
                                  ? moment(
                                      parseDateAnyFormat(ginfo.date_from),
                                    ).format("DD/MM/YYYY")
                                  : "-"}
                              </td>
                              <td
                                className="ant-table-cell"
                                style={{ border: "1px solid rgb(26, 20, 20)" }}
                              >
                                {ginfo.date_to &&
                                moment(
                                  parseDateAnyFormat(ginfo.date_to),
                                ).isValid()
                                  ? moment(
                                      parseDateAnyFormat(ginfo.date_to),
                                    ).format("DD/MM/YYYY")
                                  : "-"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                    {mergeData?.gunhaInfor?.length > 0 && (
                      <div className="guna-merge-actions">
                        <Button
                          type="primary"
                          className="modern-button modern-button-primary guna-ai-btn"
                          onClick={() => handleConfrom()}
                        >
                          Merge
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              </Card>
            )}
          </>
        )}

        <Modal
          title={t("confirm_delete")}
          open={deleteConfirmVisible}
          onCancel={onDeleteNo}
          footer={null}
          centered
          destroyOnClose
        >
          <div style={{ textAlign: "center" }}>
            <p style={{ fontSize: 16, marginBottom: 20 }}>
              सदर चा गुन्हा डिलिट करायचा आहे का?
            </p>
            <Space size="middle">
              <Button type="primary" onClick={onDeleteYes}>
                होय
              </Button>
              <Button danger onClick={onDeleteNo}>
                नाही
              </Button>
            </Space>
          </div>
        </Modal>

        <Modal
          title="सूचना"
          open={deleteNotifyVisible}
          onCancel={() => {
            if (deleteLoading) return;
            setDeleteNotifyVisible(false);
            setSelectedGunha(null);
            setDeleteReason(undefined);
          }}
          footer={null}
          centered
          destroyOnClose
          closable={!deleteLoading}
          maskClosable={!deleteLoading}
        >
          <div style={{ textAlign: "center" }}>
          <p style={{ fontSize: 16, marginBottom: 16,fontWeight: "bold" }}>
           CMIS ID : {selectedGunha?.masterId}
          </p>
            <p style={{ fontSize: 16, marginBottom: 16 }}>
              {getGunhaLabel(selectedGunha)} हा गुन्हा डिलिट करण्यासाठी admin
              यांना कळवले आहे
            </p>
            <div style={{ marginBottom: 16, textAlign: "left" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: 6,
                  fontWeight: 600,
                }}
              >
                कारण <span style={{ color: "#cf1322" }}>*</span>
              </label>
              <Select
                placeholder="कारण निवडा"
                value={deleteReason}
                onChange={onDeleteReasonChange}
                style={{ width: "100%" }}
                disabled={deleteLoading}
                getPopupContainer={(trigger) => trigger.parentNode}
              >
                {DELETE_REASON_OPTIONS.map((reason) => (
                  <Select.Option key={reason} value={reason}>
                    {reason}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <Button
              type="primary"
              loading={deleteLoading}
              disabled={!deleteReason}
              onClick={onDeleteOk}
            >
              Ok
            </Button>
          </div>
        </Modal>

        {conform && (
          <Modal
            title="Merge"
            open={conform}
            onCancel={() => handleConfrom()}
            footer={null}
            centered
          >
            <div>
              <p>
                {mergeData?.basicInfo[0]?.name} आरोपीचा सर्व गुन्हे {name} या
                आरोपी कडे वर्ग करायचे का ?
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  type="primary"
                  className="modern-button-success"
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Yes
                </Button>
                <Button
                  className="modern-button-danger"
                  style={{ marginLeft: "10px" }}
                  onClick={() => {
                    handleConfrom();
                    closeGunaViewModel();
                  }}
                >
                  No
                </Button>
              </div>
            </div>
          </Modal>
        )}
        {complete && (
          <Modal
            title="Conform"
            open={complete}
            onCancel={() => handleComplete()}
            footer={null}
            centered
          >
            <div>
              <p>गुन्हे यशस्वीरित्या मर्ज झाले आहेत व एडमिनला कळविले आहे</p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  type="primary"
                  className="modern-button-success"
                  onClick={() => {
                    handleComplete();
                    closeGunaViewModel();
                    window.location.reload();
                  }}
                >
                  Ok
                </Button>
              </div>
            </div>
          </Modal>
        )}
      </PageHeader>
      </div>
    </>
  );
};
